interface SampleOutputPreviewProps {
  value: string;
  className?: string;
}

export function SampleOutputPreview({ value, className }: SampleOutputPreviewProps) {
  const chunks = value
    .split(/#{1,6}/)
    .map((chunk) => chunk.trim())
    .filter(Boolean);

  const isKeyValue = chunks.length > 1;

  return (
    <div className={className}>
      {isKeyValue ? (
        <div className="space-y-1">
          {chunks.map((chunk, i) => {
            const colon = chunk.indexOf(":");
            if (colon > 0) {
              const label = chunk.slice(0, colon).trim();
              const val = chunk.slice(colon + 1).trim();
              return (
                <div key={i} className="flex flex-col">
                  <span className="font-medium text-text-primary">{label}</span>
                  <span className="text-text-secondary">{val}</span>
                </div>
              );
            }
            return (
              <div key={i} className="text-text-secondary">
                {chunk}
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-text-secondary whitespace-pre-wrap">{value}</p>
      )}
    </div>
  );
}
